module.exports = __webpack_public_path__ + "static/media/logo_guardian_app.cded7b49.png";